import React from "react";

export const BulkActionsBarContext = React.createContext({
  requestConfirmation: null,
  notifySelectionRequired: null,
});
